import { PersonaFullSet } from '~/data/persona'
import { checkAge } from '~/helpers/date'
import { IncomeSource, Partner } from '~/data/common'
import { NoCollateralOfferResponse } from '~/data/loans/no-collateral/offer'

const defaultDisplayNoCollateralAffiliatesCriteria = (
  noCollateralProposedOffers: Array<NoCollateralOfferResponse>,
): boolean => {
  return (
    noCollateralProposedOffers.length === 0 ||
    !noCollateralProposedOffers.some((o) => o.amount >= 200)
  )
}

const jbCredFilters = (persona: PersonaFullSet, score: number): boolean => {
  return (
    checkAge(22, 80, persona.info?.birth_date) &&
    score >= 650 &&
    persona.finance?.monthly_income >= 2500 &&
    [
      IncomeSource.CLT,
      IncomeSource.FEDERAL_WORKER,
      IncomeSource.MILITARY,
      IncomeSource.PENSION,
      IncomeSource.RETIREMENT,
    ].includes(persona.finance?.income_source ?? '') &&
    ['001', '033', '104', '237', '341'].includes(
      persona.finance?.account?.bank ?? '',
    )
  )
}

const deuTopFilters = (persona: PersonaFullSet): boolean => {
  const isNotAnnotated = !persona.finance?.annotated
  const isAgeFortyOrAbove = checkAge(40, 100, persona.info?.birth_date)
  const hasRequiredOccupation = [
    IncomeSource.RETIREMENT, // aposentado
    IncomeSource.PENSION, // pensionista
    IncomeSource.CLT, // CLT
  ].includes(persona.finance?.income_source ?? '')
  const hasRequiredIncome =
    persona.finance?.monthly_income >= 4000 &&
    persona.finance?.monthly_income <= 10000

  return (
    isNotAnnotated &&
    isAgeFortyOrAbove &&
    hasRequiredOccupation &&
    hasRequiredIncome
  )
}

const zippiFilters = (persona: PersonaFullSet, score: number): boolean => {
  const isMeiOrAutonomous = [
    IncomeSource.MEI,
    IncomeSource.AUTONOMOUS,
  ].includes(persona.finance?.income_source)
  const hasScoreAbove400 = score >= 400
  const isNotAnnotated = persona.finance?.annotated === false
  const wereNotRejected =
    sessionStorage.getItem('jb.state.affiliates.zippi.hide-offer-card') !==
    'true'

  return (
    isMeiOrAutonomous && hasScoreAbove400 && isNotAnnotated && wereNotRejected
  )
}

export const getNoCollateralAffiliates = (
  noCollateralProposedOffers: Array<NoCollateralOfferResponse>,
  persona: PersonaFullSet,
  score: number,
): Record<Partner | string, boolean> => {
  const defaultDisplayCriteria = defaultDisplayNoCollateralAffiliatesCriteria(
    noCollateralProposedOffers,
  )
  return {
    [Partner.JBCRED]: defaultDisplayCriteria && jbCredFilters(persona, score),
    [Partner.DEUTOP]: defaultDisplayCriteria && deuTopFilters(persona),
    [Partner.ZIPPI]: defaultDisplayCriteria && zippiFilters(persona, score),
  }
}
